"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interactionEndedCrossEnv = void 0;
var win_1 = require("../win");
exports.interactionEndedCrossEnv = function (_a) {
    var _b;
    var logger = _a.logger, interactionName = _a.interactionName, startTime = _a.startTime, endTime = _a.endTime;
    try {
        var appName = logger.getAppName();
        var fedops = win_1.win.fedops;
        if (!(fedops === null || fedops === void 0 ? void 0 : fedops.apps) ||
            !fedops.apps.hasOwnProperty(appName) ||
            !endTime ||
            !startTime) {
            logger.interactionEnded(interactionName);
            return;
        }
        var appEntry = fedops.apps[appName];
        if (((_b = appEntry.interactions) === null || _b === void 0 ? void 0 : _b.hasOwnProperty(interactionName)) &&
            Number.isInteger(appEntry.interactions[interactionName].timestamp)) {
            logger.interactionEnded(interactionName);
            return;
        }
        appEntry.interactions = appEntry.interactions || {};
        appEntry.interactions[interactionName] = {
            timestamp: startTime,
        };
        logger.interactionEnded(interactionName, { timeOverride: endTime });
    }
    catch (error) {
        console.error("interactionEndedCrossEnv failure", error);
    }
};
//# sourceMappingURL=interactionEndedCrossEnv.js.map